var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"my-4 py-4"},[_c('v-card-text',{staticClass:"py-0"},[_c('BarChart',{attrs:{"chart-data":_vm.salesByMonth,"height":150}})],1),_c('v-row',{staticClass:"mx-0 pa-4",attrs:{"justify":"center","align":"center"}},[_c('div',{staticClass:"h5"},[_vm._v(" المبيعات الشهرية ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }